import React from 'react';
import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';
import { ListingImage } from '../ListingPictures/ListingImage';
import { PropsWithLoadingState } from '../../../utilities';

export interface IListingSubListingItemProps {
    /** The title of the sub-listing */
    title: string;
    /** The short description of the sub-listing */
    description: string;
    /** The main photo url */
    photoUrl: string;
    /** Callback on item click */
    onClick?: () => void;
    /** (optional) Wrapper style overwrite */
    style?: React.CSSProperties;
}

export const ListingSubListingItem = ({
    title,
    description,
    photoUrl,
    onClick,
    style,
    loading,
}: PropsWithLoadingState<IListingSubListingItemProps>) => {
    const renderContent = () =>
        <Stack direction={'row'} spacing={2} justifyContent={'start'} alignItems={'stretch'} height={'100%'}>
            <Box sx={{ height: '100%', maxWidth: '30%', aspectRatio: 1, borderRadius: 1, overflow: 'hidden' }} flexShrink={0}>
                <ListingImage imageUrl={photoUrl} description={!loading ? `${title}:${description}` : undefined} loading={loading} />
            </Box>
            <Stack direction={'column'} spacing={1} justifyContent={'start'} alignItems={'stretch'} flexGrow={1}>
                <Typography fontWeight={'bold'}>{!loading ? title : <Skeleton />}</Typography>
                <Typography>{!loading ? description : <Skeleton />}</Typography>
            </Stack>
        </Stack>

    if (!onClick) {
        return <Box sx={{ p: 1, flex: 1, ...style }}>{renderContent()}</Box>;
    }

    return (
        <Paper sx={{ p: 1, flex: 1, ...style }} onClick={onClick}>
            {renderContent()}
        </Paper>
    );
}